
export default function Hero() {
  const scrollToForm = () => {
    const element = document.getElementById('application-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToVideo = () => {
    const element = document.getElementById('how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/da62b21baa3da4233dc32d5671f36223/5f702bd5232a6b596678c54b8c2cbc5b.jpeg')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/70 to-black/80"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-5 sm:px-6 lg:px-8 text-center py-32 w-full">
        <h1
          className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg"
          style={{ fontFamily: 'Playfair Display, serif', textShadow: '0 2px 12px rgba(0,0,0,0.5)' }}
        >
          The Monthly Millionaire Project
        </h1>

        <p
          className="text-lg sm:text-2xl text-amber-400 font-bold mb-8 drop-shadow-md"
          style={{ textShadow: '0 2px 8px rgba(0,0,0,0.4)' }}
        >
          A proven path to earning a million naira+ monthly
        </p>

        <p
          className="text-sm sm:text-lg text-white max-w-3xl mx-auto mb-5 leading-relaxed font-medium"
          style={{ textShadow: '0 1px 6px rgba(0,0,0,0.5)' }}
        >
          The MMP is a transformational initiative created to help individuals unlock their full potential and become the best version of themselves through mentorship, structured training, capacity building, and the development of sustainable financial leverage systems.
        </p>

        <p
          className="text-sm sm:text-lg text-white max-w-3xl mx-auto mb-10 leading-relaxed font-medium"
          style={{ textShadow: '0 1px 6px rgba(0,0,0,0.5)' }}
        >
          If you are searching for a legitimate opportunity to earn consistent monthly income while addressing real health challenges in your community? The Monthly Millionaire Project is a structured wellness business system designed to help everyday individuals start earning confidently—while developing high-capacity leaders who can build large, sustainable wellness teams.
        </p>

        <p
          className="text-sm sm:text-base text-amber-300 mb-8 font-semibold"
          style={{ textShadow: '0 1px 4px rgba(0,0,0,0.4)' }}
        >
          <strong>Banking Partners:</strong> Fidelity Bank &bull; Access Bank
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={scrollToForm}
            className="bg-amber-500 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-amber-600 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Apply for the Project
          </button>
          <button
            onClick={scrollToVideo}
            className="border-2 border-white text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            Watch How It Works
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
